import React from 'react';
import { LoginPage } from '@/pages/auth/LoginPage';

interface LoginRequiredModalProps {
  isOpen: boolean;
  nextPath: string;
}

export const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({
  isOpen,
  nextPath,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="login-required-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Authentication required"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
      }}
    >
      <LoginPage embedded redirectOnSuccess={false} nextOverride={nextPath} />
    </div>
  );
};
